import { useState, useEffect, lazy, Suspense } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
export default function ConfirmEmail() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = useState(true);
  const [token, setToken] = useState(true);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const handleSubmit = async () => {};
  const handleVerify = async (email, token) => {
    setLoading(true);
    const formData = {
      email: email,
      token: token.trim(),
      domainUrl: window.location.origin,
    };
    try {
      const result = await apiService.post(config.VERIFYCOMPANY, formData);
      setLoading(false);
      if (result.statusCode === 200) {
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch (error) {
      console.error("Reset failed:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (searchParams === null) {
      navigate("/");
    } else {
      setEmail(searchParams.get("email"));
      var letparams = searchParams.toString();
      var splitparams = letparams.split("=");
      setToken(splitparams[2]);
      handleVerify(searchParams.get("email"), splitparams[2]);
    }
  }, []);

  return (
    <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
      <div className="bg-overlay" style={{ backgroundColor: "#F2F44E" }}></div>
      <div className="auth-page-content overflow-hidden mt-lg-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="card overflow-hidden">
                {loading === false ? (
                  <div className="card overflow-hidden rounded-4 loginbox shadow">
                    {status === true ? (
                      <div className="p-lg-5 p-4">
                        <h3 className="text-center">
                          Congratulations. Email Verified !!!
                        </h3>
                        <p className="text-muted text-center">
                          Please click the below button for login
                        </p>
                        <div className="mt-4 d-grid">
                          <Link to={"/"} className="btn btn-primary w-100">
                            Login
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="p-lg-5 p-4">
                        <h3 className="text-center">
                          Email Verification failed !!!
                        </h3>
                        <p className="text-muted text-center">
                          Please click the below button for resend link again
                        </p>
                        <div className="mt-4 d-grid">
                          <button
                            onClick={handleSubmit}
                            className="btn btn-primary w-100"
                          >
                            Send Email
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="card overflow-hidden rounded-4 loginbox shadow">
                    <h3 className="text-center">Loading...</h3>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
